<template>
  <div id="deviceMagtDetail">
    <div class="headTitle">
      <span style="font-size: 18px;">{{ basicinfo.deviceName }}({{ basicinfo.sn }})</span>
      <span class="fontStyle2" />
      <span class="fontStyle1">{{ $t('BondOrUpdateDevice.OwnedCompany') }}：{{ basicinfo.companyName }}</span>
      <span class="fontStyle2" />
      <span class="fontStyle1">{{ $t('sim.serviceHours') }}：{{ basicinfo.serviceHours }}</span>
      <span class="fontStyle2" />
      <span v-if="$store.state.language == 'zh'" class="fontStyle1">{{ $t('sim.PackageName') }}：{{ basicinfo.planName }}</span>
      <span v-else class="fontStyle1">{{ $t('sim.PackageName') }}：{{ basicinfo.planNameEn }}</span>
      <!-- <span class="fontStyle2" />
      <span class="fontStyle1">{{ $t('sim.UseArea') }}：{{ basicinfo.areaListStr }}</span> -->
    </div>
    <div class="content">
      <p>{{ $t('sim.RenewalLog') }}</p>
      <stepTem :step-list="stepList" />
    </div>
  </div>
</template>

<script>
import { getDeviceRenewalLog } from '@/api/sim'
import { pagination } from '@/utils/init_table' // 分页
import i18n from '@/i18n'
import { getDateAndHour } from '@/utils/updateTime.js'
import stepTem from './stepTem'

export default {
  components: {
    stepTem
  },
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      basicinfo: {
        deviceName: null,
        sn: null,
        companyName: null,
        serviceHours: null,
        planName: null,
        planNameEn: null,
        region: null,
        areaListStr: null
      },
      companyOptions: [],
      tableList: [],
      loading: false,
      stepList: []
    }
  },
  computed: {
    statusOptions() {
      return [
        { label: i18n.t('sim.effective'), value: 1 },
        { label: i18n.t('sim.Expired'), value: 2 }
      ]
    },
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.initTable() // 初始化列表
    }
  },
  mounted() {
    var obj = JSON.parse(sessionStorage.getItem('deviceMagtRow') || '{}')
    console.log('obj', obj)
    for (var attr in this.basicinfo) this.basicinfo[attr] = obj[attr]
    var areaList = JSON.parse(obj.region) || []
    this.basicinfo.areaListStr = ''
    areaList.forEach((m, i) => {
      if (this.$store.state.language == 'zh') {
        this.basicinfo.areaListStr += i < areaList.length - 1 ? m.countryName + ',' : m.countryName
      } else {
        this.basicinfo.areaListStr += i < areaList.length - 1 ? m.countryNameEn + ',' : m.countryNameEn
      }
    })
    this.basicinfo.serviceHours = obj.activeTimeZh + ' - ' + obj.serviceEndTimeZh
    this.companyOptions = JSON.parse(sessionStorage.getItem('deviceMagtRow') || '[]')
    this.initTable()//  初始化列表
  },
  methods: {
    initTable() { // 初始化列表
      var param = {
        'mcuId': this.$route.query.mcuId
      }
      getDeviceRenewalLog(param).then(res => {
        if (res.resultCode == 1001) {
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          var arr = res.resultModel || []
          this.stepList = []
          arr.forEach(v => {
            v.title = getDateAndHour(v.createTime, 'noSecond')
            v.description = v.remark

            if (!v.remark) {
              let remark = this.$t('device_log.' + v.i18nKey)
              if (v.param) {
                const param = JSON.parse(v.param)
                for (const key in param) {
                  remark = remark.replace(key, param[key])
                }
              }
              v.description = remark
            }
            this.stepList.push(v)
          })
        }
      })
    },
    goToDetail(row) {
      var routeData = this.$router.resolve({
        path: '/sim/deviceDetail',
        query: {
          mcuId: row.yhubMcu
        }
      })
      window.open(routeData.href, '_self')
    },
    changeSearch() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.initTable()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.initTable()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.initTable()
    }
  }
}
</script>

<style lang="scss">
#deviceMagtDetail{
  .content{
    background: #fff;
    margin-top: 20px;
    padding: 20px;
  }
}
</style>
